// All of those 3 regex can be changed to ^([0-9]+.[0-9]+)+[ ]
export function StripLeadingSectionNumbering(discoveredText) {
    let parsedText = discoveredText;
    // eg: "10.13 "
    parsedText = removeReg(parsedText, new RegExp('^[0-9]+[.][0-9]+[ ]'));
    // eg: "11.22.31 "
    parsedText = removeReg(parsedText, new RegExp('^[0-9]+[.][0-9]+[.][0-9]+[ ]'));
    // eg: "134.12.3.14 "
    parsedText = removeReg(parsedText, new RegExp('^[0-9]+[.][0-9]+[.][0-9]+[.][0-9]+[ ]'));

    return parsedText;
}

// All of those 2 regex can be changed to ([0-9]+.[0-9]+)+[ ]
export function StripMidPhraseBulletNumbering(discoveredText) {
    let parsedText = discoveredText;
    // eg: "11.11 "
    parsedText = removeReg(parsedText, new RegExp('[0-9]+[.][0-9]+[ ]'));
    // eg: "11.11.11 "
    parsedText = removeReg(parsedText, new RegExp('[0-9]+[.][0-9]+[.][0-9]+[ ]'));

    return parsedText;
}

// Sometimes there are some weird characters at the beginning of the line, way beyond the standard ASCII character set
// This method strips out the "leading" characters outside of the char(32) <> char(126) range
export function StripLeadingNonAlphaNumericChars(discoveredText) {
    let parsedText = discoveredText;
    const char = parsedText[0];
    let charCode = char.charCodeAt(0);
    let allowedChar = charCode >= 32 && charCode <= 126;
    if (allowedChar) {
        return parsedText;
    }

    let indx = 0;
    let firstAllowCharIndx = 0;
    while (indx < discoveredText.length && !allowedChar && firstAllowCharIndx === 0) {
        indx += 1;
        charCode = discoveredText.charCodeAt(indx);

        if (Number.isNaN(charCode)) {
            allowedChar = false;
        } else {
            allowedChar = charCode >= 32 && charCode <= 126;
        }

        if (allowedChar) {
            firstAllowCharIndx = indx;
            break;
        }
    }

    parsedText = parsedText.substring(firstAllowCharIndx, parsedText.length);
    return parsedText;
}

// This method needs re-visiting
export function StripLeadingBulletNumbering(discoveredText) {
    let parsedText = discoveredText;
    // Single alphabitical or numerical eg: " a."," 1." or "a. ", "1. "
    parsedText = removeReg(parsedText, new RegExp('^[ ]?[A-Za-z0-9][.][ ]?'));
    // Single alphabitical or numerical between brackets eg: " (a) ", " (1) "
    parsedText = removeReg(parsedText, new RegExp('^[ ]?[(][A-Za-z0-9][)][ ]?'));
    // Double numerical eg: " 11." or "11. "
    parsedText = removeReg(parsedText, new RegExp('^[ ]?[0-9][0-9][.][ ]?'));
    // Numerical numbering at start + space eg: "112. "
    parsedText = removeReg(parsedText, new RegExp('^[0-9]+[.][ ]'));
    // Numerical numbering at start + space eg: "18.34 "
    parsedText = removeReg(parsedText, new RegExp('^[0-9]+[.][0-9]+[ ]'));
    // Roman numbering eg: "ix."
    parsedText = removeReg(parsedText, new RegExp('^[ivx]+[.][ ]'));
    // Roman numbering between brackets at start eg: "(ix) "
    parsedText = removeReg(parsedText, new RegExp('^([ivx]+)[ ]'));

    return parsedText;
}

export function StripLeadingCaptializedSubtitles(discoveredText) {
    let parsedText = discoveredText;
    let foundPos = -1;
    // Trim off "leading" CAPTIALS as this is likely to be a SUBTITLE bleeding into the discovered text
    if (parsedText.length > 100) {
        for (let i = 0; i < 100; i += 1) {
            let char = parsedText[i];
            char = char.charCodeAt(0);
            if (
                (char >= 97 && char <= 122 && foundPos === -1) ||
                (char >= 48 && char <= 57 && foundPos === -1)
            ) {
                // lower case or numeric character encountered
                foundPos = i;
                break;
            }
        }
    }

    if (foundPos > 0) {
        parsedText = parsedText.substring(foundPos - 1);
    }

    return parsedText;
}

export function TidyUpSentenceEndings(discoveredText) {
    let parsedText = discoveredText;
    // Remove the periods leading space eg: "Standard of Care ." should be "Standard of Care."
    if (
        parsedText.length > 2 &&
        parsedText.substring(parsedText.length - 2, parsedText.length) === ' .'
    ) {
        parsedText = `${parsedText.substring(0, parsedText.length - 2)}.`;
    }

    // Remove the periods leading space eg: "Standard of Care . Some other sentence." should be "Standard of Care. Some other sentence."
    parsedText = parsedText.replace(' . ', '. ');

    return parsedText;
}

export function StripPageNumbering(discoveredText) {
    let parsedText = discoveredText;
    // Page numbering "Page 1 of 11"
    parsedText = removeReg(parsedText, new RegExp('[Pp]age [0-9]+ of [0-9]+'));

    return parsedText;
}

export function TerminateAddCarriageReturn(discoveredText) {
    let parsedText = discoveredText;
    if (parsedText.includes('\n') === true) {
        parsedText = parsedText.substring(0, parsedText.indexOf('\n'));
    }

    return parsedText;
}

function removeReg(discoveredText, reg) {
    if (reg.test(discoveredText)) {
        const match = discoveredText.match(reg);
        if (match[0].length < discoveredText.length) {
            return discoveredText.replace(match, '');
        }
    }

    return discoveredText;
}

/**
 * @param  {String} a   String User Enter .
 
 * @example
 * handleTextForSearch(NDA Grant-Back) // *NDA* *Grant-Back*
 * handleTextForSearch(+NDA -MSA) //+*MSA* -*NDA*
 * handleTextForSearch(++++NDA) //+*NDA*
 * handleTextForSearch(---NDA) //-*NDA*
 * handleTextForSearch(--++NDA--++) //*NDA*
 
 */

export const handleTextForSearch = searchText => {
    const manipulatedText = searchText
        .replace(/[~`!@$%^&*(){}[\];:"'<,.>?/\\|=]/g, '')
        .split(' ')
        .filter(x => Boolean(x));

    let finalStr = '';

    for (let i = 0; i < manipulatedText.length; i += 1) {
        const word = manipulatedText[i];

        const wordWithoutPlusMinus = word.replace(/^[+-]*/g, '').replace(/[+-]*$/g, '');

        // if the word start and end with character like Grant-Back also tags like #cost

        if (/^\w.*\w$/g.test(word) || /^[^+-]+$/g.test(word)) {
            finalStr += `*${word}*`;
        }

        // if word start with + + +  So make sure there is one + in the first of the word and remove - - or ++  in the end of the string
        else if (/^\++#?\w+/g.test(word)) {
            finalStr += `+*${wordWithoutPlusMinus}*`;
            // if word start with - - - - So make sure there is one - in the first of the word and remove - - or + +  in the end of the string
        } else if (/^-+#?\w+/g.test(word)) {
            finalStr += `-*${wordWithoutPlusMinus}*`;

            // if word start with ++--+ or end with ++--- remove all of them
        } else if (/#?\w+[+-]/g.test(word) || /[+-]#?\w+/g.test(word)) {
            finalStr += `*${wordWithoutPlusMinus}*`;
        }

        if (i < manipulatedText.length - 1) finalStr = `${finalStr} `;
    }

    return finalStr;
};

export function matchTags(str) {
    let r = /(?:^|\W)#(\w+)(?!\w)/g;
    let match,
        indexes = [];

    while ((match = r.exec(str))) {
        indexes.push({
            index: match.index,
            text: match[0],
            lastIndex: match.index + match[0].length
        });
    }

    return indexes;
}

//TODO This function not used in the project so it should be deleted
// compare 2 strings, returning a match percentage
export function stringComparePercentage(str1, str2) {
    const count = str1.length > str2.length ? str1.length : str2.length;
    let hits = 0;
    let j = 0;
    let i = 0;
    while (i < str1.length) {
        if (str1.substring(i, i + 1) === ' ') {
            i += 1;
            j = str2.indexOf(' ', j) + 1;
            hits += 1;
        }

        while (j < str2.length && str2.substring(j, j + 1) !== ' ') {
            if (str1.substring(i, i + 1) === str2.substring(j, j + 1)) {
                hits += 1;
                j += 1;
                break;
            } else {
                j += 1;
            }
        }

        if (!(j < str2.length && str2.substring(j, j + 1) !== ' ')) {
            j -= 1;
        }

        i += 1;
    }

    const perc = (hits / count) * 100;
    return perc;
}
